module.exports = __webpack_public_path__ + "static/media/STC-logo-exceptional-colour.2bf3e38e.png";